/**
 * GUÍA DE LIQUIDACIÓN · «Los procesos en dibujos» (GUI-12). Datos puros, sin Angular, para probarlos con node --test.
 * Solo dice QUÉ diagramas ve cada rol; la forma y los textos de cada uno viven en la plantilla del componente
 * `app-liquidacion-guia-diagramas` (maqueta aprobada: notas/liquidacion/guia-diagramas-maqueta.html).
 */
import type { RolGuia } from './liquidacion-guia';

export interface DiagramaGuia {
  id: string;
  titulo: string;
  roles: RolGuia[] | 'todos';
}

export const DIAGRAMAS: DiagramaGuia[] = [
  { id: 'proceso-completo', titulo: 'El proceso completo', roles: 'todos' },
  { id: 'dejar-listo', titulo: 'Dejar listo al comercio', roles: ['tesorero', 'gerente', 'verificador'] },
  { id: 'dia-tesorero', titulo: 'El día del tesorero', roles: ['tesorero', 'consulta'] },
  { id: 'firmar-tanda', titulo: 'Firmar una tanda', roles: ['gerente'] },
  { id: 'pagar-banco', titulo: 'Pagar por banco', roles: ['tesorero', 'gerente'] },
  { id: 'comercio-ve', titulo: 'Lo que ve el comercio', roles: 'todos' },
  { id: 'nadie-solo', titulo: 'Nadie hace todo solo', roles: ['tesorero', 'gerente', 'verificador', 'consulta'] },
];

/** Los diagramas que le sirven a un rol: los de «todos» y los que lo nombran. */
export const diagramasDeRol = (rol: RolGuia): DiagramaGuia[] =>
  DIAGRAMAS.filter((d) => d.roles === 'todos' || d.roles.includes(rol));
